import { useDispatch } from 'react-redux'
import BlogFooter from '../../../components/blog/Footer'
import { gotoLogIn } from '../../../redux/actions/AuthActions'

import { AppContainer, Body, Button, ButtonLink, Container, Content, H2, Image, MobileHeading, Show, Text } from '../landing.styles.js'

import Brands from '../Brands'
import FooterBanner from '../FooterBanner'
import Header from '../Header'
import Join from '../Join'
import Reviews from '../Reviews'

import headerBg from './header-bg.png'
import img1 from './img1.png'
import img2 from './img2.png'
import img3 from './img3.png'
import img5 from './img5.png'

const Kitchen = () => {
  const dispatch = useDispatch()

  const openLogin = () => {
    dispatch(gotoLogIn())
  }
  return (
    <div>
      <Header
        title="Bring Your Ideas to the Table With Our Dining Room Design App"
        subtitle="See what works, share ideas and shop for your new gathering space on the DecorMatters dining room design app."
        bg={headerBg}
        meta={{
          title: 'Dining Room Design App | Download Our Dining Room Layout Design App for Virtual Decorating - Decor Matters',
          description:
            'Use our dining room design app from Decor Matters. We have a design your dining room app to use to build a space fit to your personality. Our design dining room app is easy to use and excellent for experimenting with different bedroom styles and setups. Get our app to design a dining room today at Decor Matters.'
        }}
        alt="Dining room design app for planning layouts, arranging furniture, and visualizing decor"
      />
      <Join
        title="Join over 10 million users when you use the "
        postfix=" app to design your dream dining room"
        description="The modern dining room can be a place to gather, celebrate, eat and work. Whether planning a traditional or mixed-use space, get inspired by what's possible when you design your own dining room with our app. Stage the room and set the table on your own — or with inspiration and feedback from a helpful and encouraging community of decorators, designers and enthusiasts."
      />
      <Body>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Technology + Community: The DecorMatters Dining Room Design App</H2>
            </Show>
            <Text>
              Using augmented reality (AR) technology,{' '}
              <strong>
                the{' '}
                <a target="_blank" href="https://decormatters.com">
                  DecorMatters
                </a>{' '}
                app makes designing a dining room easier than ever.
              </strong>{' '}
              Simply upload a picture of your dining room to get started. Artificial intelligence (AI) drives product recommendations relevant to your space and budget, helping you to find what you need without overspending.
              <br />
              <br />
              But <strong>it's the human element that makes our dining room design app so much fun.</strong> We have a vibrant community of creatives that participate in design challenges, get inspired by seeing other's designs and earn rewards and
              recognition. Users can like, comment and send virtual gifts to each other.
            </Text>
            <Button onClick={openLogin}>Start Design</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Technology + Community: The DecorMatters Dining Room Design App</H2>
            </Show>
            <Image src={img1} alt="Augmented reality dining room design tool for visualizing furniture and getting AI-powered decor suggestions" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>A Dining Room Design App That Helps You Purchase With Confidence</H2>
            </Show>
            <Text>
              The dining room can easily be your home's most expensive room to furnish, making a{' '}
              <a target="_blank" href="https://decormatters.com/room-layout-planner-app">
                room layout planner app
              </a>{' '}
              a crucial asset. The DecorMatters dining room design app features thousands of furniture and décor items from over 30 leading retailers, allowing you to find and buy exactly what you need. Shop and test your dining room layout with the
              app using actual furnishings from stores, including:
              <br />● Pottery Barn
              <br />● West Elm
              <br />● IKEA
              <br />● Wayfair
              <br />● CB2
              <br />
              Make a smart investment – try before you buy when you design your dining room using our app.
            </Text>
            <Button onClick={openLogin}>Start Design</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>A Dining Room Design App That Helps You Purchase With Confidence</H2>
            </Show>
            <Image src={img2} alt="Dining room layout planner with real furniture previews from top retailers like West Elm and IKEA" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Get a Membership Plan for the Best Dining Room Design App Experience</H2>
            </Show>
            <Text>
              It's easy to get started with the free version of our dining room design app to try out our templates and participate in design games. With a membership plan, you can get access to the best DecorMatters has to offer, like:
              <br />● Uploading your room and decor
              <br />● AR view
              <br />● AR ruler
              <br />● Unlimited furniture
              <br />● Unlimited templates
              <br />● Daily rewards
              <br />
              …and much more!
            </Text>
            <Button onClick={openLogin}>Start Design</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Get a Membership Plan for the Best Dining Room Design App Experience</H2>
            </Show>
            <Image src={img3} alt="Dining room design app with AR view, unlimited templates, and advanced room customization tools" />
          </MobileHeading>
        </Container>
        <AppContainer>
          <Container>
            <Show on="mobile">
              <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                Download iOS App
              </ButtonLink>
            </Show>
            <Image src={img5} alt="DecorMatters app for designing your dream dining room with community support and smart layout tools" />
            <Content>
              <H2>Download the DecorMatters Dining Room Design App to See Your New Room Come Alive</H2>
              <Text>
                Add your new dining room to the 5+ million designs created using DecorMatters. We've been featured by Architectural Digest, Apartment Therapy, Redfin and many more as the best app for home design and decorating. Whether you're
                designing a dining room,
                <a target="_blank" href="https://decormatters.com/bedroom-design-app">
                  bedroom
                </a>
                ,{' '}
                <a target="_blank" href="https://decormatters.com/bathroom-design-app">
                  bathroom
                </a>
                ,{' '}
                <a target="_blank" href="https://decormatters.com/kitchen-design-app">
                  kitchen
                </a>{' '}
                or any room in your home, DecorMatters makes it fun and easy. Plan a new space, make informed purchases and connect with others by downloading our{' '}
                <a target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                  dining room design app
                </a>{' '}
                today.
              </Text>
              <Show on="desktop">
                <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                  Download iOS App
                </ButtonLink>
              </Show>
            </Content>
          </Container>
        </AppContainer>
      </Body>
      <Brands />
      <Reviews />
      <FooterBanner />
      <BlogFooter />
    </div>
  )
}

export default Kitchen
